// install (please try to align the version of installed @nivo packages)
// yarn add @nivo/scatterplot
import { ResponsiveScatterPlot } from "@nivo/scatterplot";
import { useEffect, useState } from "react";
import { fetchV1HistoryEndPoint } from "../../../configuration";
import useFetch from "../../../global/hooks/useFetchHooks";
import { useSelector } from "react-redux";

const data = [
  {
    id: "group A",
    data: [
      {
        x: "",
        y: "",
      },
    ],
  },
];
// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
export const MyResponsiveScatterPlot = ({
  finalKeys,
  sensorData,
  legend,
  ble,
  bottom = false,
  lora = false,
}) => {
  const { activeSession } = useSelector((state) => state.sessionReducer.activeSession);
  let opened = {
    id: "Opened",
    data: [],
  };

  let closed = {
    id: "Closed",
    data: [],
  };

  console.log("finalKeys in scatter", finalKeys);
  console.log("sensorData in scatter", sensorData);
  console.log("legend in scatter", legend);
  console.log("ble in scatter", ble);
  const [deviceData, setDeviceData] = useState(data);
  const [minDate, setMinDate] = useState();
  const [maxDate, setMaxDate] = useState();

  //Extract fields needed in order to call event field history line chart
  let deviceId = sensorData.data.id;
  let fieldQuery = finalKeys;
  const { data: response } = useFetch(fetchV1HistoryEndPoint(fieldQuery), {
    method: "POST",
    body: JSON.stringify({
      accountname: activeSession.accountId,
      resourceidentifier: {
        deviceid: deviceId,
      },
    }),
    filter: {
      $nopagination: true,
    },
  });

  //need some logic here to determine the fields to extract
  useEffect(() => {
    let mounted = false;
    if (!mounted) {
      //get device list

      if (response?.error) {
        if (
          response.error_description ===
          "Invalid token type in Authorization header."
        ) {
          alert("Invalid Token, Please login first");
          return;
        } else if (response.error === "unauthorized_client") {
          alert(
            "This user is not authorized to fetch device list, please log in as device user"
          );
          return;
        }
      }
      console.log("response from device history", response);
      let res = response?.map((resp, key) => {
        let date = resp.createdon.split("Z")[0].split("T");
        let returnVal = {
          x: "".concat(date[0], " ", date[1]),
          y: resp.fields["MovementDetected"]
            ? transformMotionDetected(resp.fields["MovementDetected"])
            : transformDoorWindow(resp.fields["Door|Window"]),
        };

        console.log("resp finalPayload", returnVal);
        return returnVal;
      });
      console.log("response", res);
      let eventHistory = res?.sort(function (a, b) {
        var c = new Date(a.x);
        var d = new Date(b.x);
        return c - d;
      });
      console.log("eventHistory", eventHistory);
      // let openedVals = eventHistory.filter(val => val.y === 1)
      // let closedVals = eventHistory.filter(val => val.y === 0)
      // opened.data = openedVals
      // closed.data = closedVals
      // console.log("opened", opened)
      // console.log("closed", closed)
      //let compData = [opened, closed]
      let compData = [
        {
          id: sensorData.data.fields["MovementDetected"]
            ? "Started|Stopped"
            : "Opened|Closed",
          data: eventHistory,
        },
      ];

      setDeviceData(compData);
      // const compData = showEveryDataPoint(response, fieldQuery, sensorData, ble, bottom);
      // console.log("compData", compData)
      // // //if (deviceData != compDataInitial)
      // setDeviceData(compData)
      // let data = compData[0].data
      // console.log("min date", data[0].x)
      // console.log("max date", data[data.length-1].x)

      // setMinDate(data[0].x)
      // setMaxDate(data[data.length-1].x)

      //parsing logic goes here
      //after getting response logic to parse the data and prepare for line chart
    }
    return () => {
      mounted = true;
    };
  }, [response]);

  return (
    <ResponsiveScatterPlot
      data={deviceData === undefined ? [] : deviceData}
      margin={{ top: 60, right: 140, bottom: 70, left: 140 }}
      xScale={{ type: "point" }}
      xFormat=">-.2f"
      yScale={{ type: "linear", min: 0, max: "auto" }}
      yFormat=">-.2f"
      blendMode="multiply"
      axisTop={null}
      axisRight={null}
      axisBottom={{
        orient: "bottom",
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: "Time",
        legendPosition: "middle",
        legendOffset: 46,
      }}
      axisLeft={{
        orient: "left",
        tickPadding: 100,
        tickRotation: 0,
        legend: sensorData.data.fields["MovementDetected"]
          ? "Started Stopped"
          : "Open Close",
        legendPosition: "middle",
        legendOffset: -50,
        tickSize: function (value) {
          return 5;
        },
        format: function (value) {
          if (value === 1) {
            return sensorData.data.fields["MovementDetected"]
              ? "Started"
              : "Opened";
          } else if (value === 0) {
            return sensorData.data.fields["MovementDetected"]
              ? "Stopped"
              : "Closed";
          } else {
            return "";
          }
        },
        marginRight: 10,
      }}
      legends={[
        {
          anchor: "bottom-right",
          direction: "column",
          justify: false,
          translateX: 130,
          translateY: 0,
          itemWidth: 100,
          itemHeight: 12,
          itemsSpacing: 5,
          itemDirection: "left-to-right",
          symbolSize: 12,
          symbolShape: "circle",
          effects: [
            {
              on: "hover",
              style: {
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
    />
  );
};

function transformDoorWindow(value) {
  return value === "the door/window is closed" ? 0 : 1;
}

function transformMotionDetected(value) {
  return value === "started" ? 1 : 0;
}
